'use client';
import { useTranslations } from 'next-intl';

import { UiKitCheckboxBase } from '@/fo/ui/kit/checkbox/base';
import { BaseFieldProps } from '@/fo/ui/kit/field/base';

import { saveAgreementState } from './actions';
import { styles } from './Agreements.styles';

export interface AgreementsProps {
  getFieldProps: (name: string) => BaseFieldProps;
  pending: boolean;
  agreementSales?: string;
  agreementPrivacy?: string;
}

export function Agreements({
  getFieldProps,
  pending,
  agreementSales,
  agreementPrivacy
}: AgreementsProps) {
  const t = useTranslations();
  const slots = styles();

  const handleAgreementSalesChange = (value: boolean) => {
    getFieldProps('agreementSales').onChange?.(value);
    void saveAgreementState('AGREEMENT_SALES', value);
  };

  const handleAgreementPrivacyChange = (value: boolean) => {
    getFieldProps('agreementPrivacy').onChange?.(value);
    void saveAgreementState('AGREEMENT_PRIVACY', value);
  };

  return (
    <div className={slots.base()}>
      <UiKitCheckboxBase
        label={t.rich('form.label.agreementMarketing', {
          link: (chunks) => (
            <a
              target="_blank"
              rel="noreferrer"
              href="/legal/agreement-subscriber/"
              className={slots.link()}
            >
              {chunks}
            </a>
          )
        })}
        {...getFieldProps('agreementMarketing')}
        disabled={pending}
      />
      <UiKitCheckboxBase
        key={`privacy-${agreementPrivacy}`}
        label={t.rich('form.label.agreementPrivacyRegistration', {
          linkPD: (chunks) => (
            <a
              target="_blank"
              rel="noreferrer"
              href="/legal/agreement-users/"
              className={slots.link()}
            >
              {chunks}
            </a>
          ),
          linkPrivacy: (chunks) => (
            <a
              target="_blank"
              rel="noreferrer"
              href="/legal/politika-konfidentsialnosti/"
              className={slots.link()}
            >
              {chunks}
            </a>
          )
        })}
        {...getFieldProps('agreementPrivacy')}
        onChange={handleAgreementPrivacyChange}
        defaultChecked={agreementPrivacy === 'true'}
        disabled={pending}
      />
      <UiKitCheckboxBase
        key={`sales-${agreementSales}`}
        label={t.rich('form.label.agreementSales', {
          linkUsage: (chunks) => (
            <a
              target="_blank"
              rel="noreferrer"
              href="/legal/usloviya-ispolzovaniya-sayta-www-naos-ru/"
              className={slots.link()}
            >
              {chunks}
            </a>
          ),
          linkSales: (chunks) => (
            <a
              target="_blank"
              rel="noreferrer"
              href="/legal/usloviya-prodazhi-tovarov/"
              className={slots.link()}
            >
              {chunks}
            </a>
          )
        })}
        {...getFieldProps('agreementSales')}
        onChange={handleAgreementSalesChange}
        defaultChecked={agreementSales === 'true'}
        disabled={pending}
      />
    </div>
  );
}
